module.exports = __webpack_public_path__ + "web/img/pasterfailed.2d5776f5.jpeg";